
  import { defineComponent, PropType } from 'vue';

  import IndicatorCard from '@/common/components/redesigned/IndicatorCard.vue';
  import resizeEventListener from '@/common/mixins/resizeEventListener';
  import Tooltip from '@/common/ui/Tooltip.vue';

  import VesCalendar from '../common/calendar/VesCalendar.vue';
  import VesCalendarLegend from '../common/calendar/VesCalendarLegend.vue';

  export default defineComponent({
    name: 'DashboardsCalendar',
    mixins: [resizeEventListener],
    components: {
      VesCalendar,
      IndicatorCard,
      Tooltip,
      VesCalendarLegend,
    },
    props: {
      params: {
        type: Object as PropType<Record<string, string | number | boolean>>,
      },
      isDense: {
        type: Boolean,
        default: true,
      },
      dateNavigation: {
        type: String,
      },
    },
  });
